import { render, staticRenderFns } from "./itemsbelongings-ccan.vue?vue&type=template&id=614a429c&scoped=true"
import script from "./itemsbelongings-ccan.vue?vue&type=script&lang=js"
export * from "./itemsbelongings-ccan.vue?vue&type=script&lang=js"
import style0 from "./itemsbelongings-ccan.vue?vue&type=style&index=0&id=614a429c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a429c",
  null
  
)

export default component.exports